// PEARLI-related helpers shared across the assessment demo FE.

const DEFAULT_TOKEN = "prefer_not_to_say";

const GENDER_MAP = {
  male: "male",
  female: "female",
  "non-binary": "non_binary",
  "non binary": "non_binary",
  nonbinary: "non_binary",
  non_binary: "non_binary",
  other: "other",
  "prefer not to say": DEFAULT_TOKEN,
  "prefer-not-to-say": DEFAULT_TOKEN,
  prefer_not_to_say: DEFAULT_TOKEN,
};

const AGE_MAP = {
  "under 18": "under_18",
  "under-18": "under_18",
  under_18: "under_18",
  "18-24": "18_24",
  "18_24": "18_24",
  "18-25": "18_24", // legacy FE option
  "25-29": "25_29",
  "25_29": "25_29",
  "30-34": "30_34",
  "30_34": "30_34",
  "35-44": "35_44",
  "35_44": "35_44",
  "45-55": "45_55",
  "45_55": "45_55",
  "55+": "55_plus",
  "55 plus": "55_plus",
  "55_plus": "55_plus",
  "prefer not to say": DEFAULT_TOKEN,
  "prefer-not-to-say": DEFAULT_TOKEN,
  prefer_not_to_say: DEFAULT_TOKEN,
};

const DESCRIPTION_MAP = {
  student: "student",
  "working professional": "working_professional",
  working_professional: "working_professional",
  "executive / leadership": "executive_leadership",
  "executive leadership": "executive_leadership",
  executive_leadership: "executive_leadership",
  "caregiver / parent": "caregiver_parent",
  "caregiver parent": "caregiver_parent",
  caregiver_parent: "caregiver_parent",
  entrepreneur: "entrepreneur",
  retired: "retired",
  athlete: "athlete",
  "prefer not to say": DEFAULT_TOKEN,
  "prefer-not-to-say": DEFAULT_TOKEN,
  prefer_not_to_say: DEFAULT_TOKEN,
};

const canonicalize = (value, { underscoresTo } = {}) => {
  let v = String(value ?? "").trim().toLowerCase();
  if (underscoresTo !== undefined) v = v.replace(/_/g, underscoresTo);
  v = v.replace(/\s+/g, " ");
  return v;
};

const normalizeFromMap = (value, map, defaultValue, canonicalizeOptions) => {
  const key = canonicalize(value, canonicalizeOptions);
  return map[key] ?? defaultValue;
};

export const normalizePearliGender = (value) =>
  normalizeFromMap(value, GENDER_MAP, DEFAULT_TOKEN, { underscoresTo: "-" });

export const normalizePearliAge = (value) =>
  normalizeFromMap(value, AGE_MAP, DEFAULT_TOKEN, { underscoresTo: "-" });

export const normalizePearliDescription = (value) =>
  normalizeFromMap(value, DESCRIPTION_MAP, DEFAULT_TOKEN, { underscoresTo: " " });

export const getWorldCountriesArray = (countriesModule) => {
  // `world-countries` can be exposed as an array OR under `.default` depending on bundler interop.
  if (Array.isArray(countriesModule)) return countriesModule;
  if (Array.isArray(countriesModule?.default)) return countriesModule.default;
  return [];
};

export const buildCountryList = (countriesModule) => {
  return getWorldCountriesArray(countriesModule)
    .map((c) => ({
      name: c?.name?.common,
      code: c?.cca2,
    }))
    .filter((c) => c.name && c.code)
    .sort((a, b) => a.name.localeCompare(b.name));
};
